<script lang="ts">
	import { browser } from '$app/environment';
	import { goto } from '$app/navigation';
	import { getDisplayName } from '$lib/perps';
	import type { MarketIdentifiers } from '$lib/types/market';
	// @ts-ignore
	import { NinjaKeys } from 'ninja-keys?client';

	import { onMount } from 'svelte';

	const hotkeys = [
		{
			id: 'Home',
			title: 'Open Home',
			hotkey: 'cmd+h',
			handler: () => {
				goto('/');
			}
		},
		{
			id: 'Perps',
			title: 'Open Perps',
			hotkey: 'cmd+p',
			handler: () => {
				goto('/perps');
			}
		}
	];

	let marketList: Array<MarketIdentifiers> = [
		'sETHPERP',
		'sAVAXPERP',
		'sDYDXPERP',
		'sBTCPERP',
		'sAPEPERP',
		'sMATICPERP',
		'sARBPERP',
		'sBNBPERP',
		'sOPPERP',
		'sSOLPERP',
		'sLINKPERP',
		'sDOGEPERP',
		'sUNIPERP',
		'sAAVEPERP',
		'sGMXPERP',
		'sATOMPERP',
		'sNEARPERP',
		'sADAPERP',
		'sCRVPERP',
		'sLTCPERP',
		'sLDOPERP',
		'sFTMPERP',
		'sAXSPERP',
		'sFLOWPERP',
		'sAPTPERP',
		'sBCHPERP',
		'sFILPERP',
		'sSHIBPERP',
		'sPEPEPERP',
		'sSUIPERP',
		'sBLURPERP',
		'sXRPPERP',
		'sDOTPERP',
		'sFLOKIPERP',
		'sINJPERP',
		'sTRXPERP',
		'sSTETHPERP',
		'sETCPERP',
		'sCOMPPERP',
		'sMKRPERP',
		'sXMRPERP',
		'sYFIPERP',
		'sMAVPERP',
		'sRPLPERP',
		'sETHBTCPERP',
		'sWLDPERP',
		'sUSDTPERP',
		'sEOSPERP',
		'sRUNEPERP',
		'sXLMPERP',
		'sALGOPERP',
		'sCELOPERP',
		'sSEIPERP',
		'sZECPERP',
		'sKNCPERP',
		'sZILPERP',
		's1INCHPERP',
		'sICPPERP',
		'sXTZPERP',
		'sSUSHIPERP',
		'sENJPERP',
		'sONEPERP',
		'sFXSPERP',
		'sBALPERP',
		'sPERPPERP',
		'sRNDRPERP',
		'sUMAPERP',
		'sZRXPERP',
		'sSTETHETHPERP',
		'sTIAPERP',
		'sBONKPERP',
		'sPYTHPERP',
		'sIMXPERP',
		'sTRBPERP',
		'sMEMEPERP',
		'sANKRPERP',
		'sFETPERP',
		'sGRTPERP',
		'sJTOPERP',
		'sORDIPERP',
		'sPENDLEPERP',
		'sSTRKPERP',
		'sCVXPERP',
		'sJUPPERP',
	];

	marketList.forEach((market) =>
		hotkeys.push({
			id: market,
			title: `Change market to ${getDisplayName(market)}`,
			handler: () => {
				goto(`/perps?market=${market}`);
			},
			hotkey: ''
		})
	);

	onMount(async () => {
		if (browser) {
			const ninja = document.querySelector('ninja-keys');
			// @ts-ignore
			ninja.data = hotkeys;
		}
	});
</script>

<ninja-keys class="dark hidden" noAutoLoadMdIcons="true" />

<style>
	/* colors are copied form tailwind config, doesn't support direct usage of tw styles */
	ninja-keys {
		--ninja-text-color: #54587b;
		--ninja-accent-color: #4870ff;
		--ninja-overflow-background: #03061180;
		--ninja-modal-background: #030611;
		--ninja-selected-background: #1c1d2d;
		--ninja-secondary-text-color: #a8acd1;
		--ninja-group-text-color: #54587b;
		--ninja-secondary-background-color: #171825;
		font-family: 'Avenir Next' !important;
		--ninja-footer-background: linear-gradient(132.03deg, #151825 0%, #0b0a07 100%);
		--ninja-separate-border: 1px solid #232536;
		--ninja-backdrop-filter: blur(8px);
		--ninja-font-size: 1rem;
		@apply rounded-2xl border-fx-grey-200 border font-medium;
		--ninja-key-border-radius: 4px;
	}
</style>
